class Event {
	_id
	_data

	constructor(id, optionalData) {
		if (!id) throw new Error('Provide event id')
		this._id = id
		this._data = optionalData
	}

	get id() {
		return this._id
	}
	get data() {
		return this._data
	}
}

class PubSubEventHub {
	_subscriptions = {}

	static createEvent(eventId, optionalData) {
		return new Event(eventId, optionalData)
	}

	constructor(subscriptions) {
		if (PubSubEventHub.instance) return PubSubEventHub.instance
		this._subscriptions = subscriptions || {}
		PubSubEventHub.instance = this
	}

	async emit(event) {
		validateEvent(event)
		const callbacks = (this._subscriptions || {})[event.id]
		if (!Array.isArray(callbacks)) return
		for (const callback of callbacks) await callback(event)
	}

	subscribe(eventId, callback) {
		validateSubscriptionArgs(eventId, callback)
		if (!this._subscriptions) this._subscriptions = {}
		if (!Array.isArray(this._subscriptions[eventId]))
			this._subscriptions[eventId] = []
		this._subscriptions[eventId].push(callback)
	}

	unsubscribe(eventId, callback) {
		validateSubscriptionArgs(eventId, callback)
		if (
			!this._subscriptions ||
			!Array.isArray(this._subscriptions[eventId])
		)
			return
		this._subscriptions[eventId] = this._subscriptions[
			eventId
		].filter((_callback) => _callback !== callback)
	}
}

function validateEvent(event) {
	if (event instanceof Event === false)
		throw new Error('Not a valid event')
}

function validateSubscriptionArgs(eventId, callback) {
	if (typeof eventId !== 'string' || typeof callback !== 'function')
		throw new Error(
			'Provide event id and a callback function as arguments',
		)
}

PubSubEventHub.Event = Event

module.exports = PubSubEventHub
